// extracted by mini-css-extract-plugin
module.exports = {"destination-loading":"destination-loading_1yHsz","destination-suggestion":"destination-suggestion_2tR03"};